import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { IssueService } from '../../../../services/issue.service';
import swal from 'sweetalert2';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { getLocaleDateFormat } from '@angular/common';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issues-billing-aged-debt-grid-item',
    templateUrl: './issues-billing-aged-debt-grid-item.component.html',
})
export class IssuesBillingAgedDebtGridItemComponent implements OnInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService) {

        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['billingAgedDebtPage']) {
                    this.page = +queryParams['billingAgedDebtPage'];
                } else { this.page = 1 }
            }));


        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getBillingAgedDebtDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesBillingAgedDebtGridItemComponentResolved.next(false); }
        }, error => this.dataService.issuesBillingAgedDebtGridItemComponentResolved.next(false)
        );
    }

    onInfoClick() {
        swal({
            title: 'Consumers with debt balance',
            html: '<p style="text-align: left;">This widget shows a high-level count of all consumers with debt balances in your Billing Portfolio. This includes closed consumer accounts with debt balances.</p>\
                   <p style="text-align: left;">We may be able to help manage any debt on your portfolio by utilising our <b>debt management services</b>, for more information discuss with your client account manager.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
